import React from "react";
import { toUKDateString } from "@/lib/utils";

export default function Status(props: {
  object: {
    completedOn: Date | null;
  };
}): React.ReactNode {
  if (props.object.completedOn != null) {
    return (
      <div className="px-2 py-1 rounded-lg bg-yellow-100 text-yellow text-xs">
        Completed ({toUKDateString(props.object.completedOn)})
      </div>
    );
  }
  return (
    <div className="px-2 py-1 rounded-lg bg-blue-100 text-blue text-xs">
      Active
    </div>
  );
}
